var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 35,
    viewBox: "0 0 14 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pmug756jda",
    d: "M0 0.698L13.43 0.698 13.43 14.331 0 14.331z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M2.795.818C1.858.46 1.275.533.04.69c.558.588 1.353 1.323 2.247 1.666 1.118.427 1.777-.124 1.777-.124S4.045 1.296 2.795.818",
    transform: "translate(0 1) translate(2 16.302)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91D9BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    d: "M2.795.818C1.858.46 1.275.533.04.69c.558.588 1.353 1.323 2.247 1.666 1.118.427 1.777-.124 1.777-.124S4.045 1.296 2.795.818z",
    transform: "translate(0 1) translate(2 16.302)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M6.495.818C7.432.46 8.017.533 9.252.69c-.558.588-1.353 1.323-2.248 1.666-1.118.427-1.777-.124-1.777-.124s.02-.936 1.268-1.414",
    transform: "translate(0 1) translate(2 16.302)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91D9BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    d: "M6.495.818C7.432.46 8.017.533 9.252.69c-.558.588-1.353 1.323-2.248 1.666-1.118.427-1.777-.124-1.777-.124s.02-.936 1.268-1.414z",
    transform: "translate(0 1) translate(2 16.302)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M6.511 22.327L6.92 22.327 6.92 13.855 6.511 13.855z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91D9BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    d: "M6.511 22.327L6.919 22.327 6.919 13.856 6.511 13.856z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(0 .302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jnwa65hq5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pmug756jda"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M13.43 7.576c0-.992-.57-1.808-2.144-1.91 1.079-1.22.918-2.219.22-2.929-.69-.7-1.662-.868-2.847.19-.086-1.638-.896-2.23-1.884-2.23-.976 0-1.78.579-1.88 2.177-1.202-1.095-2.187-.933-2.885-.224-.69.702-.856 1.687.187 2.89-1.615.088-2.198.91-2.198 1.912 0 .992.57 1.808 2.145 1.91-1.08 1.22-.919 2.219-.22 2.929.69.701 1.662.868 2.846-.19.087 1.638.897 2.23 1.884 2.23.976 0 1.78-.579 1.88-2.177 1.204 1.095 2.188.933 2.885.224.691-.701.856-1.687-.186-2.889 1.614-.089 2.197-.911 2.197-1.913M6.715 9.181c-.906 0-1.641-.747-1.641-1.667 0-.921.735-1.667 1.641-1.667.905 0 1.64.746 1.64 1.667 0 .92-.735 1.667-1.64 1.667",
    mask: "url(#jnwa65hq5b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M11.876 24.172L12.07 24.172 12.323 24.172 12.975 21.073 1.271 21.073 1.924 24.172 2.136 24.172 2.361 24.172z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M2.431 24.576L3.5 30.797 2.145 30.797 2.797 32.303 11.449 32.303 12.101 30.797 10.788 30.797 11.81 24.576z",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers);
export default __webpack_public_path__ + "static/media/flowers.9e8f59d037cba36c67ac99aaeff02f1e.svg";
export { ForwardRef as ReactComponent };